import React, { useCallback, useLayoutEffect, useState } from "react";
import { classnames, ClickClose, Panel, PlainButton, SearchBar } from "@culturehq/components";

import { useUserAutocomplete } from "app/hooks";
import { t } from "app/utils";
import getUserName from "app/utils/getUserName";

const userAutocompleteOptions = {};

const PhotoTagging = ({ onClose, onTag, position }) => {
  const [searchKey, setSearchKey] = useState(1);
  const [users, setUsers] = useState([]);

  const onSearch = useUserAutocomplete(
    userAutocompleteOptions,
    useCallback(results => setUsers(results.users), [setUsers])
  );

  useLayoutEffect(
    () => {
      setSearchKey(value => value + 1);
      setUsers([]);
    },
    [setSearchKey, setUsers, position]
  );

  return (
    <ClickClose
      className={classnames("photo-tagging", { "photo-tagging-results": users.length > 0 })}
      style={{ left: position.clientX, top: position.clientY }}
      onClose={onClose}
    >
      <Panel>
        <SearchBar
          key={searchKey}
          autoComplete="off"
          autoFocus
          onSearch={onSearch}
          placeholder={t("Search...")}
        />
        {users.map(user => (
          <PlainButton key={user.id} onClick={() => onTag(user)}>
            {getUserName(user)}
          </PlainButton>
        ))}
      </Panel>
    </ClickClose>
  );
};

export default PhotoTagging;
